import React from "react";

import { getSecDifination } from "../../Services/auth";

export const TenantSecDefinition = () => {
	const secDifination = getSecDifination();
	if (!secDifination) return <></>;
	return (
		<div
			style={{
				position: "absolute",
				top: "50px",
				left: 0,
				zIndex: 999,
				backgroundColor: "#fff",
				padding: "8px",
				color: "#333",
				borderRadius: "4px",
				boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
				whiteSpace: "pre-wrap"
			}}
		>
			{secDifination}
		</div>
	);
};

export default TenantSecDefinition;
